// extracted by css-extract-rspack-plugin
export default {"container":"container-BPB_tB","label":"label-cJpA9Z","value":"value-ZD6L6x","icon":"icon-DruDf9"};